import Vue from 'vue'
import Router from 'vue-router'
import store from './store'


const TheContainer = () => import('@/containers/TheContainer')
const Dashboard = () => import('@/views/Dashboard')
Vue.use(Router)

export default new Router({
  mode: 'hash', 
  linkActiveClass: 'active',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({
    y: 0
  }),
  routes: configRoutes()
})

function configRoutes() {
  return [{
      path: '/Home',
      redirect: '/client/dashboard',
      name: 'Home',
      component: TheContainer,
      
       

            
      children: [{
        
          path: 'client/dashboard',
          name: 'Dashboard',
          component: Dashboard,
          
        },

        
        
        {
          path: '/ajouterService',
          name: 'ajouterService',
          component: () => import('@/components/DG/ajouterService.vue'),
        },
        {
          path: '/ajouter_vid_man',
          name: 'ajouter_vid_man',
          component: () => import('@/components/DG/ajouter_vid_man.vue'),
        },

        {
          path: '/ajout_matr',
          name: 'ajout_matr',
          component: () => import('@/components/DG/ajout_matr.vue'),
        },
        {
          path: '/listes_societe',
          name: 'listes_societe',
          component: () => import('@/components/DG/listes_societe.vue'),
        },
        {
          path: '/listesRetenues',
          name: 'listesRetenues',
          component: () => import('@/components/DG/listesRetenues.vue'),
        },
        
        {
          path: '/ajouterRetenus',
          name: 'ajouterRetenus',
          component: () => import('@/components/DG/ajouterRetenus.vue'),
        },
        {
          path: '/ajout_societe',
          name: 'ajout_societe',
          component: () => import('@/components/DG/ajout_societe.vue'),
        },
        {
          path: '/modif_societe/:id',
          name: 'modif_societe',
          component: () => import('@/components/DG/modif_societe.vue'),
        },
        
        {
          path: '/SommeTVA/:id',
          name: 'Somme-TVA',
          component: () => import('@/components/DG/SommeTVA.vue'),
        },
        
        
        
        
        {
          path: '/mise_a_jour_service_man/:id',
          name: 'mise_a_jour_service_man',
          component: () => import('@/components/DG/mise_a_jour_service_man.vue'),
        },

        /* mise a jour vidange */
        {
          path: '/mise_a_jour_vidange_man/:id',
          name: 'mise_a_jour_vidange_man',
          component: () => import('@/components/DG/mise_a_jour_vidange_man.vue'),
        },
        {
          path: '/mise_jour_vidange_okba/:id',
          name: 'mise_jour_vidange_okba',
          component: () => import('@/components/DG/mise_jour_vidange_okba.vue'),
        },

        {
          path: '/ajouterVidangeOkba',
          name: 'ajouterVidangeOkba',
          component: () => import('@/components/DG/ajouterVidangeOkba.vue'),
        },

        {
          path: '/listes_services_ajouter_okba',
          name: 'listes_services_ajouter',
          component: () => import('@/components/DG/listes_services_okba.vue'),
        },
        {
          path: '/listes_services_passage',
          name: 'listes_services_passage',
          component: () => import('@/components/DG/listes_services_passage.vue'),
        },
        {
          path: '/factures_service_okba_paye',
          name: 'factures_service_okba_paye',
          component: () => import('@/components/DG/factures_service_okba_paye.vue'),
        },
        {
          path: '/facture/:id',
          name: 'facture',
          component: () => import('@/components/DG/factures.vue'),
        },
        {
          path: '/edit_service/:id',
          name: 'edit_service',
          component: () => import('@/components/DG/edit_service.vue'),
        },

        
        {
          path: '/edit_facture/:id',
          name: 'edit_facture',
          component: () => import('@/components/DG/edit_facture.vue'),
        },
        {
          path: '/edit_kilometrage/:id',
          name: 'edit_kilometrage',
          component: () => import('@/components/DG/edit_kilometrage.vue'),
        },
        
        
        {
          path: '/recherche_num_facture',
          name: 'recherche_num_facture',
          component: () => import('@/components/DG/recherche_num_facture.vue'),
        },
        {
          path: '/factures_service_okba_non_paye',
          name: 'factures_service_okba_non_paye',
          component: () => import('@/components/DG/factures_service_okba_non_paye.vue'),
        },
        {
          path: '/detaille_service/:id',
          name: 'detaille_service',
          component: () => import('@/components/DG/detaille_service.vue'),
        },

        {
          path: '/factures_service_societe/:id',
          name: 'factures_service_societe',
          component: () => import('@/components/DG/factures_service_societe.vue'),
        },
        {
          path: '/factures_vidange_societe/:id',
          name: 'factures_vidange_societe',
          component: () => import('@/components/DG/factures_vidange_societe.vue'),
        },

        {
          path: '/update_trait_vid/:id',
          name: 'update_trait_vid',
          component: () => import('@/components/DG/update_trait_vid.vue'),
        },

        {
          path: '/update_trait_vid_okba/:id',
          name: 'update_trait_vid_okba',
          component: () => import('@/components/DG/update_trait_vid_okba.vue'),
        },
        {
          path: '/add_trait_service/:id',
          name: 'add_trait_service',
          component: () => import('@/components/DG/add_trait_service.vue'),
        },
        {
          path: '/add_trait_vidange_man/:id',
          name: 'add_trait_vidange_man',
          component: () => import('@/components/DG/add_trait_vidange_man.vue'),
        },
        
        

        
        
        {
          path: '/update_trait_service/:id',
          name: 'update_trait_service',
          component: () => import('@/components/DG/update_trait_service.vue'),
        },
        

        {
          path: '/detaille_facture_service/:id',
          name: 'detaille_facture_service',
          component: () => import('@/components/DG/detaille_facture_service.vue'),
        },

        {
          path: '/detaille_facture_vidange/:id',
          name: 'detaille_facture_vidange',
          component: () => import('@/components/DG/detaille_facture_vidange.vue'),
        },

        
          {
          path: '/Tirage_deatille_facture/:id',
          name: 'Tirage_deatille_facture',
          component: () => import('@/components/DG/Tirage_deatille_facture.vue'),
        }, 
        
        {
          path: '/vidange_deatille_facture/:id',
          name: 'vidange_deatille_facture',
          component: () => import('@/components/DG/vidange_deatille_facture.vue'),
        },
        {
          path: '/ajouterBlocNote',
          name: 'ajouterBlocNote',
          component: () => import('@/components/DG/ajouterBlocNote.vue'),
        },

        {
          path: '/ajouterBloc',
          name: 'ajouterBloc',
          component: () => import('@/components/DG/ajouterBloc.vue'),
        },

        {
          path: '/Statistiques',
          name: 'Statistiques',
          component: () => import('@/components/DG/Statistiques.vue'),
        },

        

        
        {
          path: '/miseAJourBlocNote/:id',
          name: 'miseAJourBlocNote',
          component: () => import('@/components/DG/miseAJourBlocNote.vue'),
        },

        

        {
          path: '/listes_bloc_note',
          name: 'listes_bloc_note',
          component: () => import('@/components/DG/listes_bloc_note.vue'),
        },
        {
          path: '/archive',
          name: 'Archive',
          component: () => import('@/components/DG/Archive.vue'),
        },
        {
          path: '/show',
          name: 'show',
          component: () => import('@/components/DG/show.vue'),
        },

        {
          path: '/show_ajouterBlocNote/:id',
          name: 'show_ajouterBlocNote',
          component: () => import('@/components/DG/show_ajouterBlocNote.vue'),
        },
        {
          path: '/edit_ajouterBlocNote/:id',
          name: 'edit_ajouterBlocNote',
          component: () => import('@/components/DG/edit_ajouterBlocNote.vue'),
        },
        

        

        

        
        {
          path: '/detaille_vidange/:id',
          name: 'detaille_vidange',
          component: () => import('@/components/DG/detaille_vidange.vue'),
        },
        

            
        {
          path: '/vidange',
          name: 'vidange',
          component: () => import('@/components/DG/listes_vidange_okba_equipe.vue'),
        },

        
        
        
        
      ]
    },

    
     {
      path: '/',
      name: 'Accueil',
      component: () => import('@/components/Auth/Login.vue'),
    },
   {
      path: '/inscription',
      name: 'Accueil',
      component: () => import('@/components/Auth/registerEquipe.vue'),
    },
{
      path: '/admin',
      name: 'Accueil',
      component: () => import('@/components/Auth/LoginAdmin.vue'),
    },
    
    
    {
      path: '/accueil',
      name: 'Accueil',
      component: () => import('@/components/Accueil.vue'),
    },
    {
      path: '/AccueilORIGINAL',
      name: 'AccueilORIGINAL',
      component: () => import('@/components/AccueilORIGINAL.vue'),
    },
    
    {
      path: '/moez',
      name: 'contact',
      component: () => import('@/components/contact.vue'),
    },
    

    {
      path: '/res',
      name: 'res',
      component: () => import('@/components/res.vue'),
    },

     {
      path: '/resRs',
      name: 'resRs',
      component: () => import('@/components/resRs.vue'),
    },
  ]
}







